import router from '@router'
import store from '@state/store'
import Vue from 'vue'

import { documentModule } from '@modules/documents'
import { portfolioModule } from '@modules/portfolio'
import { financeModule } from '@modules/finance'
import { professionalsModule } from '@modules/professionals'
import { partnershipModule } from '@modules/partnership'
import { dailyTasksModule } from '@modules/daily_tasks'
import { settingsModule } from '@modules/settings'
import { globalModule } from '@modules/global'
import { aawzDriveModule } from '@modules/aawz-drive'
import { controladoriaV2Module } from '@modules/controladoria-v2'
import { clientsModule } from '@modules/clients'
import { powerBiModule } from '@modules/power-bi'
import { consolidatorModule } from '@modules/consolidator'
import { calendarModule } from '@modules/calendar'
import { comissoesModule } from '@modules/comissoes'
import { dataRoomModule } from '@modules/data-room'
import { captableModule } from '@modules/captable'
import { boletadorModule } from '@modules/boletador'
import { tesourariaModule } from '@modules/tesouraria'
import { billingSystemModule } from '@modules/billing-system'
import { opportunitiesModule } from '@modules/opportunities'
import { commissionsModule } from '@modules/commissions/index'
import { corretoraModule } from '@modules/corretora/index'
import { rhModule } from '@modules/rh'
import { dashboardModule } from '@modules/dashboard'
import { commercialModule } from '@modules/commercial'
import { aawzIntelligenceV2Module } from '@modules/aawz-intelligence-v2'
import { eventosModule } from '@modules/eventos/index'
import { backOfficeModule } from '@modules/back-office/index'
import { complianceModule } from '@modules/compliance'
import { homeModule } from '@modules/home/index'
import { newsModule } from '@modules/news/index'
import { notificationsModule } from '@modules/notifications'
import { fpModule } from '@modules/financial-planning'
import { wsModule } from '@modules/ws'
import { crmModule } from '@modules/crm'
import { requisicoesModule } from '@modules/requisicoes'
import { solicitacoesModule } from '@modules/solicitacoes'
import { tarefasModule } from '@modules/tarefas'
import { atendimentoModule } from '@modules/atendimento'
import { workflowEngineModule } from '@modules/workflow-engine'
import { feeFixoModule } from '@modules/fee-fixo'
import { navegacaoV2Module } from '@modules/navegacao-v2'
import { aiFrameworkModule } from '@modules/ai-framework'
import { clientJourneyModule } from '@modules/client-journey'
import { centralConfigModule } from '@modules/central-config'
import { npsModule } from '@modules/nps'
import { professionalWaitlistModule } from '@modules/professional-waitlist'

export function registerModule(module) {
  module({ app: Vue, store, router })
}

export function registerAllModules() {
  const modules = [
    documentModule,
    portfolioModule,
    financeModule,
    professionalsModule,
    partnershipModule,
    dailyTasksModule,
    settingsModule,
    globalModule,
    aawzDriveModule,
    controladoriaV2Module,
    clientsModule,
    powerBiModule,
    consolidatorModule,
    tesourariaModule,
    billingSystemModule,
    boletadorModule,
    comissoesModule,
    captableModule,
    dataRoomModule,
    opportunitiesModule,
    calendarModule,
    commissionsModule,
    corretoraModule,
    rhModule,
    dashboardModule,
    commercialModule,
    eventosModule,
    aawzIntelligenceV2Module,
    backOfficeModule,
    homeModule,
    newsModule,
    notificationsModule,
    fpModule,
    wsModule,
    crmModule,
    complianceModule,
    requisicoesModule,
    solicitacoesModule,
    tarefasModule,
    atendimentoModule,
    workflowEngineModule,
    feeFixoModule,
    navegacaoV2Module,
    aiFrameworkModule,
    centralConfigModule,
    clientJourneyModule,
    npsModule,
    professionalWaitlistModule,
  ]

  modules.forEach((module) => registerModule(module))
}
